import EventBus from '../../common/EventBus';

export default class SelectedJobsState {
  constructor() {
    if (typeof window.Application.selected_jobs === 'undefined') {
      // selected_jobs are getting passed in from html.erb
      window.Application.selected_jobs = [];
    }
  }

  selectedJobs() {
    return window.Application.selected_jobs;
  }

  ids() {
    return this.selectedJobs().map((job) => parseInt(job.work_item_id));
  }

  ppiItemsOnly() {
    return this.ids().every((id) => window.Application.PRE_PURCHASE_INSPECTIONS.indexOf(id) > -1);
  }

  lastAddedJob() {
    return this.selectedJobs().slice(-1)[0] || null;
  }

  add(id, description) {
    const job = {
      description: description,
      work_item_id: id,
    };
    window.Application.selected_jobs.push(job);
    EventBus.emit('jobs:added', { job, jobs: this.selectedJobs() });
  }

  remove(id) {
    window.Application.selected_jobs = this.selectedJobs().filter((job) => job.work_item_id !== id);
    EventBus.emit('jobs:removed', { id, jobs: this.selectedJobs() });
  }

  clear() {
    window.Application.selected_jobs = [];
    EventBus.emit('jobs:cleared', { jobs: this.selectedJobs() });
  }
}
